module.exports = __webpack_public_path__ + "static/img/nimage.088bd0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nimage.png
// module id = 9uLX
// module chunks = 2